import type { OrganizationEnvironment } from '@/lib/api/generated/model';

/** How each environment reads, on General and in the console's scope bar. */
export const ENVIRONMENT_LABELS: Record<OrganizationEnvironment, string> = {
  production: 'Production',
  staging: 'Staging',
};

/**
 * The scope bar's chip (spec 167): Production in the warning tone, because a
 * change made there reaches real people; Staging in the quieter info tone.
 * Words as well as colour, so the colour is never the only signal.
 */
export const ENVIRONMENT_CHIP: Record<OrganizationEnvironment, string> = {
  production: 'border-state-warning/40 bg-state-warning/10 text-state-warning',
  staging: 'border-state-info/40 bg-state-info/10 text-state-info',
};
